<!-- TEMPLATE -->
<template>
    <div class="dean-nullable-switch">
        <input v-model="switchValue" type="radio" :name="name" id="false" :value="false"/>
        <input v-model="switchValue" type="radio" :name="name" id="null" :value="null"/>
        <input v-model="switchValue" type="radio" :name="name" id="true" :value="true"/>
    </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
    // VUE
    // import Vue from 'vue';
    import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator';

    @Component({
        components: {
        },
    })

    export default class DeanNullableSwitch extends Vue {
        // DATA
        private switchValue: any = null;
        @Prop({default: ''}) protected name!: string;
        @Prop({default: null}) protected value!: any;

        // METHODS
        @Watch('switchValue')
        public propagateInput(input: any) {
            this.$emit('input', this.switchValue);
        }

        @Watch('value')
        public valueChanged(value: any) {
            this.switchValue = this.value;
        }
    }
</script>

<!-- STYLE -->
<style lang="scss" scoped>

    // IMPORT
    @import '~@deanone/dean-components/src/scss/vars';

    .dean-nullable-switch {
        padding: 5px 10px;
    }

    input[type="radio"] {
        position: relative;
        background: var(--color-light-shade-2, $color-light-shade-2);
        width:30px;
        height: 30px;
        transition: background .4s;
        overflow:hidden;
        border-top: 1px solid var(--color-light-shade-2, $color-light-shade-2);
        border-bottom: 1px solid var(--color-light-shade-1, $color-light-shade-1);
    }

    input[type="radio"]:first-child {
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
        border-left: 1px solid var(--color-light-shade-1, $color-light-shade-1);
    }


    input[type="radio"]:last-child {
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
        border-right: 1px solid var(--color-light-shade-1, $color-light-shade-1);
    }

    input[type="radio"]:before {
        width: 30px;
        height: 30px;
        position: absolute;
        text-align:center;
        font-size: 22px;
        display:grid;
    }

    #false:before {
        content: "✕";
    }

    #null:before {
        content: "−";
    }

    #true:before {
        content: "✓";
    }

    input[type="radio"]:hover:before {
        cursor: pointer;
        background-color: var(--color-light-shade-1, $color-light-shade-1);
    }


    input[type="radio"]:checked {
        background: var(--color-primary, $color-primary);
        box-shadow: inset 0 0 3px 0 rgba(0,0,0,0.2);
        &:hover:before {
            background: var(--color-primary, $color-primary);
        }
        &:checked:before {
            color: white;
        }
    }
</style>
